class RoleType {
  public static get ALL() {
    return 1;
  }

  public static get SCOPE() {
    return 2;
  }
}

RoleType[RoleType.ALL] = {
  label: 'Không giới hạn',
  // color: 'bg-error-400'
};
RoleType[RoleType.SCOPE] = {
  label: 'Giới hạn theo tổ chức',
  // color: 'bg-error-400'
};

export default RoleType;
